<template>
  <div>
    <div>
      <label>Chest:</label>
      <input
        :class="$style.input"
        type="text"
        disabled
        :value="canvasOutput.output1"
      >
    </div>



  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState(['canvasOutput'])
  },
  mounted() {
    this.$emit('title', 'Measurements')
    this.$emit('prevLink', 'MobileCanvasInput')
    this.$emit('nextLink', 'Main')
  }
}
</script>

<style lang="scss" module>
.input {
  display: block;
  width: 100%;
  padding: 10px;
  margin: 10px;
  color: red;
  font-weight: 900;
}
</style>